import script from "./CartProductGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CartProductGroup.vue?vue&type=script&setup=true&lang=js"

import "./CartProductGroup.vue?vue&type=style&index=0&id=2cb017b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb017b8"]])

export default __exports__